import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WalletSharedService {
  addFund = false;
  plaid: string = '';

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  @Output()
  updatePlaid: EventEmitter<string> = new EventEmitter();

  constructor() {}

  toggle(status: boolean) {
    this.addFund = status;
    this.update.emit(this.addFund);
  }

  togglePlaid(status: string) {
    this.plaid = status;
    this.updatePlaid.emit(this.plaid);
  }
}
